import { tabsAnatomy } from '@chakra-ui/anatomy';
import { createMultiStyleConfigHelpers } from '@chakra-ui/react';

const { definePartsStyle, defineMultiStyleConfig } = createMultiStyleConfigHelpers(
  tabsAnatomy.keys,
);

const variant = definePartsStyle(() => ({
  root: { display: 'flex', w: 'full', gap: '32px' },
  tab: {
    w: 'full',
    boxSize: 'border-box',
    ps: { laptop: '4px', mobile: '2px' },
    py: { laptop: '4px', mobile: '2px' },
    pe: { laptop: '32px', mobile: '16px' },
    border: '1px solid',
    borderColor: 'transparent',
    borderRadius: { laptop: '48px', mobile: '24px' },
    justifyContent: 'space-between',
    transition: 'all .2s',
    '.leftIcon': { boxSize: { laptop: '32px', mobile: '16px' } },
    '.rightIcon': { opacity: '0', boxSize: { laptop: '24px', mobile: '16px' } },
    '.tabText': {
      fontSize: { mobile: '12px', laptop: '16px' },
      fontWeight: '500',
      textAlign: 'start',
    },
    _hover: {
      border: '1px solid',
      borderColor: 'line.gray !important',
      '.rightIcon': { transition: 'all .2s', opacity: '1' },
    },
    _selected: {
      bgColor: 'bg.grayLight',
      '.rightIcon': { opacity: '1' },
    },
  },
  tablist: { w: 'full', flexDirection: 'column', gap: '16px' },
  tabpanels: {
    w: 'full',
    maxW: '452px',
    overflow: 'hidden',
    borderRadius: { mobile: '24px', laptop: '48px' },
    bgColor: 'bg.grayLight',
  },
  tabpanel: {
    w: 'full',
    h: 'full',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'start',
    p: 'unset',
  },
}));

const variants = {
  tabs: variant,
};

const Tabs = defineMultiStyleConfig({ variants, defaultProps: { variant: 'tabs' } });

export default Tabs;
